import React from "react";

function PageNotFound() {
  return <div className="h1">Page Not Found</div>;
}

export default PageNotFound;
